import * as React from 'react';

import { Body } from 'bones/design-system/components/typography/Body';

export const BreadcrumbDivider: React.VFC = () => (
  <Body className="vb-breadcrumb-divider" size="md">
    /
  </Body>
);
